import { createSlice } from '@reduxjs/toolkit';

import { API_STATUS } from '../types';

import { ACTION_TYPE_PARENT } from './actions';

const INITIAL_STATE = {
  status: API_STATUS.idle,
  modelsList: []
}

/* eslint-disable no-param-reassign */
export const authSlice = createSlice({
  name: ACTION_TYPE_PARENT,
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers(builder) {
  }
})
/* eslint-disable no-param-reassign */

export default authSlice.reducer;